

function generateNameForLayer(values, isAddingType) {

    var name = ''

    if (isAddingType === 'line') {
        const {
            origin,
            destination,
            viaPointsIds,
        } = values

        if (origin && destination)
            name = `${origin.name} to ${destination.name}`

        if (viaPointsIds.length > 0) {
            name += ` with ${viaPointsIds.length} via point(s)`
        }

    } else if (isAddingType === 'marker') {
        const {
            markerStation,
            lat,
            lon,
        } = values

        if (markerStation) {
            name = markerStation.name
        }
        
        if (lat && lon) {
            name = `Custom location ${lat}, ${lon}`
        }
    }

    return name
}

module.exports = {
    generateNameForLayer,
}